import { render, staticRenderFns } from "./streamer.vue?vue&type=template&id=49c15d84&scoped=true"
import script from "./streamer.vue?vue&type=script&lang=js"
export * from "./streamer.vue?vue&type=script&lang=js"
import style0 from "./streamer.vue?vue&type=style&index=0&id=49c15d84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c15d84",
  null
  
)

export default component.exports